import { Component, input } from '@angular/core';
import * as fromAssistants from '../assistants';
import { TeammateVisual } from '../teammates/teammate-avatar.config';
import { TeammateVisualComponent } from '../teammates/teammate-visual.component';

@Component({
  selector: 'squadbox-introduction',
  imports: [fromAssistants.AssistantLogoComponent, TeammateVisualComponent],
  template: `
    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-6 tablet-landscape:gap-4">
        <!-- Image -->
        <div
          class="size-14 tablet-landscape:size-16 overflow-hidden rounded-lg relative"
          [class.bg-primary-100]="!teammate()"
          [class.p-4]="!teammate()"
        >
          @if (teammate()) {
            <squadbox-teammate-visual
              class="h-full w-full"
              [visual]="visual()!"
              presentation="page-header"
            />
          } @else {
            <!-- ⚠️ text-primary-300 like every other skill surface, but the
                 bg-primary-100 tile STAYS. Two separate decisions, and they were
                 measured apart.

                 The glyph: primary-500/50 composited to #858dfe at hue 236° here
                 — visibly PURPLE beside the same skill's blue #87a5fc (225°) in
                 the sidebar and the profile panel. A skill icon is not
                 color-configurable, unlike a teammate icon, so it must not shift
                 hue by surface.

                 The tile: swapping it to bg-primary-50 would match the other two
                 tinted tiles exactly and recover contrast (2.24 rather than
                 1.92), but it was tried in the browser and the tile all but
                 disappears into the page at this 56/64px size. The stronger tint
                 is what gives the largest rendering of the icon its presence, and
                 that reads as deliberate. So: hue fixed, tile untouched, and the
                 1.92:1 accepted knowingly — the skill name sits beside it, so the
                 glyph is not the sole carrier of meaning. Reported from the
                 running app by @maxeber. -->
            <squadbox-assistant-logo
              class="
                [&>svg,img]:text-primary-300
              "
              [logo]="imagePath()"
            />
          }
        </div>

        <!-- Description and subtitle -->
        <div class="typo-h6 wrap-anywhere">
          <span>{{ title() }}</span>
          @if (subtitle()) {
            <p class="text-neutral-500">{{ subtitle() }}</p>
          }
        </div>
      </div>

      <!-- Divider -->
      <div class="border-t border-neutral-200"></div>
    </div>
  `,
})
export class IntroductionComponent {
  public readonly teammate = input<boolean>(false);
  /** Assistant-logo identifier — used in the non-teammate branch. */
  public readonly imagePath = input<string>('');
  /**
   * Resolved teammate visual — required when `teammate` is true.
   *
   * SB-3519: this is the discriminated union, not the avatar config. The
   * non-teammate branch below is untouched and stays that way — the chat
   * conversation reaches this component without `teammate`, so it takes the
   * skill-logo path, and OQ-4 (#1264) put that surface permanently out of
   * scope: a conversation is with a skill, not a teammate.
   */
  public readonly visual = input<TeammateVisual>();
  public readonly title = input.required<string>();
  public readonly subtitle = input<string>();
}
